<template>
	<div>
		<el-dialog
			:visible.sync="submitFlowDialog"
			:before-close="handleClose"
			title="Submit Project"
			:fullscreen="false"
			width="650px"
			class="header"
			:close-on-press-escape="false"
			:destroy-on-close="true"
		>
			<div style="margin-top: 15px">
				<el-row style="margin-top: 0px">
					<el-col :span="6" :offset="1">
						<div><b>Location name</b></div>
					</el-col>
					<el-col :span="16" :offset="1">
						<span style="text-transform: capitalize; word-break: break-word">
							{{
								project_info_object.location_info
									? project_info_object.location_info.name
									: ""
							}}</span
						>
					</el-col>
				</el-row>
				<el-row style="margin-top: 20px">
					<el-col :span="6" :offset="1">
						<div><b>Project name</b></div>
					</el-col>
					<el-col :span="16" :offset="1">
						<span style="text-transform: capitalize; word-break: break-word">{{
							project_info_object.project_name
						}}</span>
					</el-col>
				</el-row>
				<el-row style="margin-top: 20px">
					<el-col :span="6" :offset="1">
						<div><b>Points</b></div>
					</el-col>
					<el-col :span="16" :offset="1">
						{{
							project_info_object.task_status_update_info
								? project_info_object.task_status_update_info.current_score
								: ""
						}}
						of
						{{
							project_info_object.task_status_update_info
								? project_info_object.task_status_update_info.total_score
								: ""
						}}
						( 100% )
					</el-col>
				</el-row>
				<el-row
					v-if="
						project_info_object.is_submitted &&
						project_info_object.auditor_sign_file_path != null
					"
					style="margin-top: 20px"
				>
					<el-col :span="6" :offset="1">
						<div><b>Submitted on</b></div>
					</el-col>
					<el-col :span="16" :offset="1">
						{{
							project_info_object.is_submitted
								? moment(project_info_object.submitted_at)
										.local()
										.format("Do MMM YY, HH:mm:ss")
								: "-"
						}}
					</el-col>
				</el-row>
				<!-- v-if="
						this.project_info_object.execution_setup_info.manual_user_assignment
					" -->
				<el-row
					v-if="
						!project_info_object.is_submitted &&
						project_info_object.execution_setup_info
							? project_info_object.execution_setup_info.auditor_name_required
							: ''
					"
					style="margin-top: 20px"
				>
					<el-col :span="6" :offset="1">
						<div><b>Auditor </b></div>
					</el-col>
					<el-col :span="15" :offset="1">
						<el-select
							class="select"
							v-model="auditor"
							filterable
							placeholder="Select Your Name"
							v-validate="'required'"
							name="Select User"
							style="text-transform: capitalize"
							popper-class="select-dropdown-width"
						>
							<el-option
								v-for="item in auditorList"
								:key="item.id"
								:label="item.full_name"
								:value="item.id"
							>
							</el-option>
						</el-select>
						<p>
							<span
								:v-show="errors.has(`Select User`)"
								class="text-red-dark text-xs"
							>
								{{
									errors.first(`Select User`) ? "This field is required" : ""
								}}
							</span>
						</p>
					</el-col>
				</el-row>
				<el-row
					v-if="
						!project_info_object.is_submitted &&
						project_info_object.execution_setup_info
							? project_info_object.execution_setup_info.auditor_image_required
							: ''
					"
					style="margin-top: 20px; margin-bottom: 40px"
				>
					<el-col :span="6" :offset="1"> </el-col>
					<el-col :span="15" :offset="1">
						<el-button
							v-if="getButtonCondition"
							icon="el-icon-upload2"
							class="button-class"
							@click="startWebcam"
							:loading="uploadLoading"
						>
							Upload Your Image
						</el-button>
						<canvas
							:hidden="true"
							ref="canvas"
							width="640"
							height="480"
						></canvas>
						<video
							v-if="showVideo"
							ref="video"
							width="100%"
							height="300"
							autoplay
						></video>
						<img
							v-if="imageCaptured"
							:src="capturedImageData"
							alt="Captured Image"
						/>
					</el-col>
				</el-row>
				<div
					style="
						display: flex;
						justify-content: flex-end;
						margin-right: 20px;
						margin-bottom: 60px;
						margin-top: -40px;
					"
				>
					<el-button
						v-if="showVideo"
						class="button-class"
						@click="captureImage"
					>
						Capture Image
					</el-button>
					<el-button
						v-if="imageCaptured"
						class="button-class"
						@click="reuploadImage"
						:loading="uploadLoading"
					>
						Reupload Image
					</el-button>
				</div>

				<el-row
					v-if="
						!project_info_object.is_submitted &&
						project_info_object.execution_setup_info
							? project_info_object.execution_setup_info.auditor_sign_required
							: ''
					"
					style="margin-top: 20px"
				>
					<el-col :span="6" :offset="1">
						<div><b>Auditor Signature</b></div>
					</el-col>
					<el-col :span="15" :offset="1">
						<div style="border: 1px solid" id="app">
							<canvas ref="signatureCanvas"></canvas>
						</div>
						<el-row style="margin-top: 0px">
							<el-col :span="9" :offset="15">
								<el-button
									@click="clearSignature"
									class="button-class-white2"
									style="border: none"
								>
									Clear Signature
								</el-button>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
				<el-row style="margin-top: 20px">
					<el-col :span="6" :offset="1">
						<div><b>Remarks </b></div>
					</el-col>
					<el-col :span="15" :offset="1">
						<el-input
							type="textarea"
							:rows="4"
							placeholder="Enter Remarks"
							v-model="remarks"
							class="input-class"
							:minlength="0"
							:maxlength="350"
							show-word-limit
						>
						</el-input>
					</el-col>
				</el-row>
				<el-row
					v-if="
						!project_info_object.is_submitted &&
						project_info_object.execution_setup_info
							? project_info_object.execution_setup_info.auditee_name_required
							: ''
					"
					style="margin-top: 20px"
				>
					<el-col :span="6" :offset="1">
						<div><b>Auditee </b></div>
					</el-col>
					<el-col :span="15" :offset="1">
						<el-select
							class="select"
							v-model="auditee"
							filterable
							placeholder="Select Name"
							v-validate="'required'"
							name="Select Auditee"
							style="text-transform: capitalize"
							popper-class="select-dropdown-width"
						>
							<el-option
								v-for="item in auditeeList"
								:key="item.id"
								:label="item.full_name"
								:value="item.id"
							>
							</el-option>
						</el-select>
						<p>
							<span
								:v-show="errors.has(`Select Auditee`)"
								class="text-red-dark text-xs"
							>
								{{
									errors.first(`Select Auditee`) ? "This field is required" : ""
								}}
							</span>
						</p>
					</el-col>
				</el-row>
				<el-row
					v-if="
						!project_info_object.is_submitted &&
						project_info_object.execution_setup_info
							? project_info_object.execution_setup_info.auditee_sign_required
							: ''
					"
					style="margin-top: 20px"
				>
					<el-col :span="6" :offset="1">
						<div><b>Auditee Signature</b></div>
					</el-col>
					<el-col :span="15" :offset="1">
						<div style="border: 1px solid" id="app">
							<canvas
								v-if="auditee_sign_file_path_url == null"
								ref="signatureCanvasAuditee"
							></canvas>
							<img
								v-if="auditee_sign_file_path_url != null"
								class="uploaded-image"
								:src="auditee_sign_file_path_url"
								alt="Image Preview"
								id="preview-img"
							/>
						</div>
						<el-row style="margin-top: 0px">
							<el-col :span="9" :offset="15">
								<el-button
									@click="handleAuditeeClick"
									class="button-class-white2"
									style="border: none"
								>
									Clear Signature
								</el-button>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
				<el-row
					v-if="
						project_info_object.is_submitted &&
						project_info_object.auditor_sign_file_path != null
					"
					style="margin-top: 20px"
				>
					<el-col :span="6" :offset="1">
						<div><b>Submitted By</b></div>
					</el-col>
					<el-col :span="6" :offset="1">
						{{ project_info_object.auditor_info.full_name }} <br />
						<div style="font-size: 12px">
							( {{ project_info_object.auditor_info.designation_info.name }} )
						</div>
					</el-col>
				</el-row>
				<el-row
					v-if="
						project_info_object.is_submitted &&
						project_info_object.auditor_sign_file_path != null
					"
					style="margin-top: 20px"
				>
					<el-col :span="6" :offset="1">
						<div><b>Auditor Signature</b></div>
					</el-col>
					<el-col :span="6" :offset="1">
						<img
							class="uploaded-image"
							:src="auditor_sign_file_path_url"
							alt="Image Preview"
							id="preview-img"
						/>
					</el-col>
				</el-row>
				<el-row
					v-if="
						project_info_object.is_submitted &&
						project_info_object.auditor_sign_file_path != null
					"
					style="margin-top: 20px"
				>
					<el-col :span="6" :offset="1">
						<div><b>Auditee Name</b></div>
					</el-col>
					<el-col :span="6" :offset="1">
						{{ project_info_object.user_assigned_info.full_name }} <br />
					</el-col>
				</el-row>
				<el-row
					v-if="
						project_info_object.is_submitted &&
						project_info_object.auditor_sign_file_path != null
					"
					style="margin-top: 20px"
				>
					<el-col :span="6" :offset="1">
						<div><b>Auditee Signature</b></div>
					</el-col>
					<el-col :span="6" :offset="1">
						<img
							class="uploaded-image"
							:src="auditee_sign_file_path_url"
							alt="Image Preview"
							id="preview-img"
						/>
					</el-col>
				</el-row>
				<el-row style="margin-top: 30px">
					<el-col
						:span="3"
						:offset="project_info_object.is_submitted ? 20 : 16"
					>
						<el-button
							@click="$emit('close')"
							class="button-class-white2"
							style="border: none"
							:loading="loading"
						>
							Cancel
						</el-button>
					</el-col>
					<el-col
						v-if="!project_info_object.is_submitted"
						style="margin-bottom: 40px"
						:span="3"
						:offset="1"
					>
						<el-button
							:loading="loading"
							class="button-class"
							@click="save_form()"
						>
							Submit
						</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import SignaturePad from "signature_pad";
import licenseManagementService from "../../../../services/licenseManagementService";
import formBuilderServices from "../../../../services/formBuilderServices";
import { set } from "vue";
var moment = require("moment");

export default {
	components: {
		SignaturePad,
	},
	props: {
		submitFlowDialog: Boolean,
		project_info_object: Object,
	},
	data: () => ({
		moment: moment,
		auditee: null,
		auditeeList: [],
		auditor_sign_file_path_url: null,
		auditee_sign_file_path_url: null,
		signaturePad: null,
		signaturePadAuditee: null,
		loading: false,
		auditorList: [],
		auditor: "",
		remarks: "",
		capturedImageData: null,
		imageCaptured: false,
		videoStream: null,
		showVideo: false,
		showCanvas: false,
		showUploadButton: true,
		uploadLoading: false,
	}),
	computed: {
		getButtonCondition() {
			let show_button = true;
			if (this.showVideo) {
				show_button = false;
			}
			if (this.capturedImageData) {
				show_button = false;
			}
			return show_button;
		},
	},
	watch: {
		async submitFlowDialog(val) {
			if (val) {
				this.showUploadButton = true;
				this.capturedImageData = null;
				this.imageCaptured = false;
				this.showVideo = false;
				console.log(this.project_info_object, "project_info_object");
				this.auditee = null;
				this.$validator.reset();
				this.remarks = this.project_info_object.review;
				if (
					!this.project_info_object.is_submitted &&
					this.project_info_object.execution_setup_info &&
					this.project_info_object.execution_setup_info.auditee_name_required
				) {
					this.getAllAuditees();
				}
				if (
					!this.project_info_object.is_submitted &&
					this.project_info_object.execution_setup_info &&
					this.project_info_object.execution_setup_info.auditor_name_required
				) {
					this.getAllAuditors(
						this.project_info_object.execution_setup_info.designations
					);
				}
				if (
					!this.project_info_object.is_submitted &&
					this.project_info_object.execution_setup_info.auditor_sign_required
				) {
					this.initSignaturePad();
				}
				if (this.project_info_object.auditor_sign_file_path != null) {
					let params = {
						file_path: this.project_info_object.auditor_sign_file_path,
						storage: "task",
					};
					const res = await formBuilderServices.getAttachmentURL(params);
					this.auditor_sign_file_path_url = JSON.parse(res.data).data;
				}
				if (this.project_info_object.auditee_sign_file_path != null) {
					let params = {
						file_path: this.project_info_object.auditee_sign_file_path,
						storage: "task",
					};
					const res = await formBuilderServices.getAttachmentURL(params);
					this.auditee_sign_file_path_url = JSON.parse(res.data).data;
				} else {
					this.initSignaturePadAuditee();
				}
			}
		},
	},
	methods: {
		handleAuditeeClick() {
			if (this.auditee_sign_file_path_url) {
				this.auditee_sign_file_path_url = null;
				this.initSignaturePadAuditee();
			} else {
				this.clearSignatureAuditee();
			}
		},
		reuploadImage() {
			// this.uploadLoading = true;
			setTimeout(() => {
				this.showUploadButton = false;
				this.imageCaptured = false;
				this.capturedImageData = null;
			}, 500);
			this.startWebcam();
		},
		startWebcam() {
			this.uploadLoading = true;
			navigator.mediaDevices
				.getUserMedia({ video: true })
				.then((stream) => {
					this.videoStream = stream;
					this.showVideo = true;
					setTimeout(() => {
						this.uploadLoading = false;
						this.$refs.video.srcObject = stream;
					}, 500);
				})
				.catch((err) => {
					this.uploadLoading = false;
					this.$notify.error({
						title: "Fail",
						message: `Unable to access the webcam; try again later.`,
					});
					console.error("Error accessing webcam:", err);
					this.stopVideo();
				});
		},
		captureImage() {
			if (!this.imageCaptured) {
				// Check if image has not been captured yet
				const video = this.$refs.video;
				const canvas = this.$refs.canvas;
				const context = canvas.getContext("2d");
				context.drawImage(video, 0, 0, canvas.width, canvas.height);
				this.capturedImageData = canvas.toDataURL("image/png");
				this.imageCaptured = true;
				this.stopVideo();
			}
		},
		stopVideo() {
			if (this.videoStream) {
				const tracks = this.videoStream.getTracks();
				tracks.forEach((track) => track.stop()); // Stop each track in the stream
				const videoTracks = this.videoStream.getVideoTracks();
				if (videoTracks.length > 0) videoTracks[0].stop(); // Stop the video track explicitly
				if (this.$refs.video) this.$refs.video.srcObject = null; // Remove the video source
				this.videoStream = null; // Clear the stream variable
				this.$set(this, "showVideo", false); // Update the reactive variable
			}
		},
		getAllAuditors(designations) {
			let params = {
				designations: designations,
				store: this.project_info_object.location_info.id,
				user_groups: [],
				access_levels: ["outlet", "employee"],
			};
			formBuilderServices.getUsersOnSubmitPage(params).then((res) => {
				this.auditorList = JSON.parse(res.data);
			});
		},
		async save_form() {
			try {
				const result = await this.$validator.validateAll();
				if (result) {
					this.loading = true;
					if (
						this.project_info_object.execution_setup_info &&
						this.project_info_object.execution_setup_info.auditor_image_required
					) {
						if (this.capturedImageData) {
							await this.saveImage();
						} else {
							this.$notify.error({
								title: "Fail",
								message: `Upload Image`,
							});
							this.loading = false;
							return false;
						}
					}
					if (this.signaturePad) {
						await this.saveSignature();
					}
					if (this.signaturePadAuditee) {
						await this.saveSignatureAuditee();
					}
					this.call_submit_form_api();
				} else {
					this.$notify.error({
						title: "Fail",
						message: `Enter required fields`,
					});
					this.loading = false;
				}
			} catch (error) {
				this.loading = false;
				console.error("Error in save_form:", error);
			}
		},
		async saveImage() {
			try {
				if (this.capturedImageData) {
					const dataURL = this.capturedImageData;
					const blob = this.dataURLToBlob(dataURL);
					const file = new File(
						[blob],
						`Auditor Image ${Math.floor(new Date().getTime() / 1000)}.png`,
						{ type: "image/png" }
					);
					const formData = new FormData();
					formData.append("attachments", file);
					formData.append("storage", "task");
					const res = await formBuilderServices.uploadImageAttachment(formData);
					this.capturedImageDataUploaded = JSON.parse(res.data).data;
				}
			} catch (error) {
				console.error("Error in saveSignature:", error);
			}
		},
		async saveSignatureAuditee() {
			try {
				if (this.signaturePadAuditee) {
					if (this.signaturePadAuditee.isEmpty()) {
						this.$notify.error({
							title: "Fail",
							message: `Enter Signature`,
						});
						this.loading = false;
						return;
					}
					const dataURL = this.signaturePadAuditee.toDataURL();
					const blob = this.dataURLToBlob(dataURL);
					const file = new File(
						[blob],
						`Auditee signature ${Math.floor(new Date().getTime() / 1000)}.png`,
						{ type: "image/png" }
					);
					const formData = new FormData();
					formData.append("attachments", file);
					formData.append("storage", "task");
					const res = await formBuilderServices.uploadImageAttachment(formData);
					this.signaturePadAuditeeUploaded = JSON.parse(res.data).data;
				}
			} catch (error) {
				console.error("Error in saveSignature:", error);
			}
		},
		async saveSignature() {
			try {
				if (this.signaturePad) {
					if (this.signaturePad.isEmpty()) {
						this.$notify.error({
							title: "Fail",
							message: `Enter Signature`,
						});
						this.loading = false;
						return;
					}
					const dataURL = this.signaturePad.toDataURL();
					const blob = this.dataURLToBlob(dataURL);
					const file = new File(
						[blob],
						`Auditor signature ${Math.floor(new Date().getTime() / 1000)}.png`,
						{ type: "image/png" }
					);
					const formData = new FormData();
					formData.append("attachments", file);
					formData.append("storage", "task");
					const res = await formBuilderServices.uploadImageAttachment(formData);
					this.signaturePadUploaded = JSON.parse(res.data).data;
				}
			} catch (error) {
				console.error("Error in saveSignature:", error);
			}
		},
		dataURLToBlob(dataURL) {
			const parts = dataURL.split(";base64,");
			const contentType = parts[0].split(":")[1];
			const raw = window.atob(parts[1]);
			const array = new Uint8Array(new ArrayBuffer(raw.length));
			for (let i = 0; i < raw.length; i++) {
				array[i] = raw.charCodeAt(i);
			}
			return new Blob([array], { type: contentType });
		},
		call_submit_form_api() {
			let params = {
				project_id: this.project_info_object.id,
				submitted: true,
				auditee_sign_file_path:
					this.project_info_object.execution_setup_info &&
					this.project_info_object.execution_setup_info.auditee_sign_required
						? this.auditee_sign_file_path_url == null
							? this.signaturePadAuditeeUploaded != null
								? this.signaturePadAuditeeUploaded[0].file_path
								: null
							: this.project_info_object.auditee_sign_file_path
						: null,
				auditor: null,
				user_assigned: null,
				review: this.remarks,
				auditor_image_file_path: null,
				auditor_sign_file_path: null,
				auditee: null,
				submitted_on_device: "web",
			};
			if (
				!this.project_info_object.is_submitted &&
				this.project_info_object.execution_setup_info.auditor_sign_required
			) {
				params.auditor_sign_file_path = this.signaturePadUploaded[0].file_path;
			}
			if (
				!this.project_info_object.is_submitted &&
				this.project_info_object.execution_setup_info.auditor_name_required
			) {
				params.user_assigned = this.auditor;
			}
			if (
				!this.project_info_object.is_submitted &&
				this.project_info_object.execution_setup_info.auditee_name_required
			) {
				params.auditee = this.auditee;
			}
			if (
				this.project_info_object.execution_setup_info &&
				this.project_info_object.execution_setup_info.auditor_image_required
			) {
				params.auditor_image_file_path =
					this.capturedImageDataUploaded[0].file_path;
			}

			formBuilderServices.markSubmitted(params).then((res) => {
				this.$emit("clicked");
				this.$notify.success({
					title: "Success",
					message: "Form Submitted Successfully",
				});
				setTimeout(() => {
					this.loading = false;
				}, 1000);
			});
		},
		getAllAuditees() {
			let params = {
				designations:
					this.project_info_object.execution_setup_info.auditee_designations,
				store: this.project_info_object.location_info.id,
				user_groups: [],
			};
			licenseManagementService
				.fetchAllUsersByDesignations(params)
				.then((res) => {
					this.auditeeList = JSON.parse(res.data);
				});
		},
		initSignaturePad() {
			setTimeout(() => {
				const canvas = this.$refs.signatureCanvas;
				this.$forceUpdate();
				if (canvas) {
					this.signaturePad = new SignaturePad(canvas);
				} else {
					console.error("Canvas element not found.0");
					this.$emit("reopen");
				}
			}, 1000);
		},
		initSignaturePadAuditee() {
			setTimeout(() => {
				const canvas1 = this.$refs.signatureCanvasAuditee;
				this.$forceUpdate();
				if (canvas1) {
					this.signaturePadAuditee = new SignaturePad(canvas1);
				} else {
					console.error("Canvas element not found.1");
					this.$emit("reopen");
				}
			}, 1000);
		},
		clearSignature() {
			if (this.signaturePad) {
				this.signaturePad.clear();
			}
		},
		clearSignatureAuditee() {
			if (this.signaturePadAuditee) {
				this.signaturePadAuditee.clear();
			}
		},

		handleClose() {
			this.$emit("close");
		},
	},
};
</script>

<style>
.header .el-dialog__header {
	background: white;
	color: black;
	border-bottom: 1px solid grey;
}
.header .el-dialog__title {
	text-transform: capitalize;
	color: black;
}
.el-message-box__header {
	background-color: white;
	border: white;
}
.image-container {
	max-width: 100%;
	max-height: 490px;
	overflow-y: auto; /* Set maximum height as per your requirement */
	margin-bottom: 20px; /* Add margin between images */
	text-align: center;
}

.uploaded-image {
	width: auto;
	height: auto;
}
</style>
